<template>
	<div style="height: 100%">
		<ElInput
			type="textarea"
			v-model="value"
			:autoResize="true"
			v-on:change="handler($event)"
		/>
	</div>
</template>

<script>
import ElInput from "element-ui/lib/input";

export default {
	name: "tableEditor",
	components: {
		ElInput
	},
	data() {
		return {
			value: String
		};
	},
	beforeMount() {
		this.value = this.params.data[this.params.column.colId];
	},
	mounted() {
		//const editorElement = this.$refs.editorElement;
		const editorElement = this.params.eGridCell;
		editorElement.addEventListener("change", event => {
			console.log("EditorEvent:", event);
			console.log("Caller Component", this.params.caller);
			if (this.params.caller === "StudyCharacteristics") {
				this.$tera.project.detableStudyCharacteristics.rows[this.params.rowIndex][
					this.params.colDef.field
				] = this.params.data[this.params.colDef.field];
			}
			if (this.params.caller === "StudyOutcomes") {
				this.$tera.project.detableSudyOutcome.rows[this.params.rowIndex][
					this.params.colDef.field
				] = this.params.data[this.params.colDef.field];
			} else {
				this.$tera.project.planTable.rows[this.params.rowIndex][
					this.params.colDef.colId
				] = this.params.data[this.params.colDef.colId];
			}
		});
	},
	methods: {
		handler(event) {
			this.params.setValue(event);
		}
	}
};
</script>
<style>
.el-textarea {
	height: 100% !important;
}
.el-textarea__inner {
	resize: none !important;
	border: 0px !important;
	background-color: transparent !important;
	min-height: 100% !important;
	font-family: Arial, Helvetica, sans-serif;
}
</style>
